export const DONOR_LIST_PAGINATION = {
    pageSize: 20,
    pageSizes: [20, 50],
    allPagesSize: true,
    startPage: 1,
};

export const PUSH_MESSAGES_PAGINATION = {
    pageSize: 20,
    pageSizes: [20, 50],
    allPagesSize: true,
    startPage: 1,
};